import { useOrganizationStore } from '@shared/hooks/state/OrganizationContainer';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { useAlertsStore } from './state/AlertsContainer';

export function useLicenseKeyFetching() {
    const { t } = useTranslation();
    const { organizationId } = useParams<{ organizationId: string }>();
    const isLoading = useOrganizationStore((state) => state.loadingData.licenseKeys);
    const orgManagedLicenseKeys = useOrganizationStore((state) => state.orgManagedLicenseKeys);

    useEffect(() => {
        async function initializeLicenseKeys() {
            const organizationState = useOrganizationStore.getState();
            if (!organizationId || organizationState.loadingData.licenseKeys == true) return;
            organizationState.handleLoadingDataChange('licenseKeys', true);
            const key = organizationState.orgManagedLicenseKeys.find(
                (k) => k.originatedByOrganizationId === organizationId
            );

            if (key) {
                organizationState.handleLoadingDataChange('licenseKeys', false);
                return;
            }

            try {
                await organizationState.getOrgManagedLicenseKeys(organizationId);
            } catch (error) {
                useAlertsStore.getState().showError(t('common:license.key.error'));
            } finally {
                organizationState.handleLoadingDataChange('licenseKeys', false);
            }
        }
        initializeLicenseKeys();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [organizationId]);

    return {
        orgManagedLicenseKeys,
        isLoading,
    };
}
